(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3161],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fcategories%2Findex.tsx&page=%2Fcategories!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories",
      function () {
        return __webpack_require__("./src/pages/categories/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Elements/Image/Image.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* unused harmony export cfLoader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next/image.js");
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




const BASE_URL = "https://iq.wiki";
const cfLoader = (param)=>{
    let { src , width , quality  } = param;
    const params = [
        "width=".concat(width)
    ];
    if (quality) params.push("quality=".concat(quality));
    const paramsString = params.join(",");
    return "".concat(BASE_URL, "/cdn-cgi/image/").concat(paramsString, "/").concat(normalizeSrc(src));
};
const normalizeSrc = (src)=>{
    return src.startsWith("/") ? src.slice(1) : src;
};
const Image = (param)=>/*#__PURE__*/ {
    let { src , alt , priority , placeholder , blurDataURL , hideOnError , sizes , objectFit ="cover" , imgBoxSize , imgW , imgH , ...rest } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        h: "".concat(imgBoxSize || imgH, "px"),
        w: "".concat(imgBoxSize || imgW, "px"),
        ...rest,
        overflow: "hidden",
        position: "relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            quality: 95,
            style: {
                objectFit,
                objectPosition: "top",
                width: "100%",
                height: "100%"
            },
            loader: typeof src === "string" && src.startsWith("http") ? cfLoader : undefined,
            fill: !(imgW && imgH) || !imgBoxSize,
            src: src,
            alt: alt,
            onError: (e)=>{
                if (hideOnError) {
                    e.currentTarget.style.visibility = "hidden";
                }
            },
            priority: priority,
            sizes: sizes,
            placeholder: placeholder,
            blurDataURL: blurDataURL,
            loading: priority ? "eager" : "lazy",
            width: imgBoxSize || imgW,
            height: imgBoxSize || imgH
        })
    });
};


/***/ }),

/***/ "./src/data/AllCategoriesData.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AllCategoriesData; }
/* harmony export */ });
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");

const AllCategoriesData = [
    {
        id: "nfts",
        title: "NFTs",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiImage2Fill */ .RXd,
        description: "The NFTs (non-fungible tokens) category covers all things NFT from collections like the Bored Ape Yacht Club to games like Axie Infinity to artists like Beeple.",
        cardImage: "/images/categories/nfts-card.png",
        heroImage: "/images/categories/nfts.png"
    },
    {
        id: "defi",
        title: "Decentralized Finance",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiMoneyCnyCircleFill */ .CDL,
        description: "The Decentralized Finance (DeFi) category covers everything from stablecoin projects like Frax Finance to concepts like Yield Farming to the oracles which power DeFi like Chainlink.",
        cardImage: "/images/categories/defi-card.png",
        heroImage: "/images/categories/defi.png"
    },
    {
        id: "exchanges",
        title: "Exchanges",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiExchangeBoxFill */ .zZv,
        description: "The Exchanges category covers all crypto exchanges including both centralized exchanges like Binance or Coinbase and decentralized exchanges like Uniswap or Quickswap.",
        cardImage: "/images/categories/exchanges-card.png",
        heroImage: "/images/categories/exchanges.png"
    },
    {
        id: "cryptocurrencies",
        title: "Cryptocurrencies",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiBitCoinFill */ .KCp,
        description: "This cryptocurrencies category covers all cryptocurrencies from Bitcoin to IQ. ",
        cardImage: "/images/categories/cryptocurrencies-card.png",
        heroImage: "/images/categories/cryptocurrencies.jpg"
    },
    {
        id: "daos",
        title: "DAOs",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiTeamFill */ .Qeh,
        description: "The DAOs category covers decentralized autonomous organizations of all kinds from DeFi DAOs like Olympus DAO to knowledge focused DAOs like BrainDAO.",
        cardImage: "/images/categories/daos-card.png",
        heroImage: "/images/categories/daos.png"
    },
    {
        id: "people",
        title: "People in crypto",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiUser3Fill */ .IIZ,
        description: "The People in Crypto category covers everyone working to grow the crypto space from developers to artists to marketers to policy makers and everyone in between.",
        cardImage: "/images/categories/people-card.png",
        heroImage: "/images/categories/people.png"
    },
    {
        id: "dapps",
        title: "Decentralized Applications",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiCopperDiamondLine */ .qGc,
        description: "The Decentralized Application (dapps) category covers everything from time-weighted average market maker (TWAMM) like Fraxswap to DeFi lending protocols like Aave.",
        cardImage: "/images/categories/dapps-card.png",
        heroImage: "/images/categories/dapps.jpg"
    },
    {
        id: "organizations",
        title: "Organizations",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiOrganizationChart */ .W7I,
        description: "The Organizatons category covers companies and other organizations that develop, implement, or utilize blockchain technology.",
        cardImage: "/images/categories/organizations-card.png",
        heroImage: "/images/categories/organizations.jpg"
    }
];


/***/ }),

/***/ "./src/data/Constants.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ ITEM_PER_PAGE; },
/* harmony export */   "L": function() { return /* binding */ WIKI_METADATA_VALUE_LIMIT; },
/* harmony export */   "Nf": function() { return /* binding */ FETCH_DELAY_TIME; },
/* harmony export */   "Vl": function() { return /* binding */ CATEGORY_DESCRIPTION_WORD_LIMIT; },
/* harmony export */   "a": function() { return /* binding */ WIKI_SUMMARY_LIMIT; },
/* harmony export */   "ag": function() { return /* binding */ WIKI_IMAGE_ASPECT_RATIO; },
/* harmony export */   "ft": function() { return /* binding */ MEDIA_POST_DEFAULT_ID; },
/* harmony export */   "hj": function() { return /* binding */ WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL; },
/* harmony export */   "xh": function() { return /* binding */ IMAGE_BOX_SIZE; }
/* harmony export */ });
/* unused harmony exports WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS, GPT3_COST_PER_1K_TOKENS, GPT3_MAX_TRIES */
const ITEM_PER_PAGE = 12;
const FETCH_DELAY_TIME = 3000;
const CATEGORY_DESCRIPTION_WORD_LIMIT = 200;
const MEDIA_POST_DEFAULT_ID = "UPLOADING_ID";
const WIKI_IMAGE_ASPECT_RATIO = 4 / 3;
const WIKI_METADATA_VALUE_LIMIT = 255;
const WIKI_SUMMARY_LIMIT = 255;
const WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL = 10 * 60 * 1000 // 10 Mins
;
const WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS = 5;
const GPT3_COST_PER_1K_TOKENS = 0.02;
const GPT3_MAX_TRIES = 3;
const IMAGE_BOX_SIZE = 150;


/***/ }),

/***/ "./src/pages/categories/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ categories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkOverlay.tsx
var LinkOverlay = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");
;// CONCATENATED MODULE: ./src/components/Categories/CategoryCard.tsx






const CategoryCard = (props)=>{
    const { imageCard , coverIcon , title , brief , categoryId  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* LinkBox */.fG, {
        bgColor: "cardBg",
        borderWidth: "1px",
        borderColor: "dimColor",
        _hover: {
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)"
        },
        overflow: "hidden",
        borderRadius: "12px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
            cursor: "pointer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    w: "100%",
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: imageCard,
                            width: "full",
                            height: "150px",
                            alt: title,
                            loading: "lazy",
                            imgW: Constants/* IMAGE_BOX_SIZE */.xh * Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                            imgH: Constants/* IMAGE_BOX_SIZE */.xh
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            position: "absolute",
                            bottom: "0",
                            left: "50%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                transform: "translateX(-50%) translateY(50%)",
                                as: coverIcon,
                                borderRadius: "100px",
                                overflow: "hidden",
                                borderWidth: "5px",
                                bgColor: "hsl(".concat(Math.floor(Math.random() * 360), ", 70%, 80%)"),
                                color: "#0000002f",
                                borderColor: "cardBg",
                                width: "60px",
                                height: "60px",
                                padding: 2
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    p: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            textAlign: "center",
                            size: "sm",
                            my: "10px",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOverlay/* default */.Z, {
                            href: "/categories/".concat(categoryId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                maxWidth: "300px",
                                fontSize: "xs",
                                textAlign: "center",
                                opacity: "0.6",
                                children: brief.length > Constants/* CATEGORY_DESCRIPTION_WORD_LIMIT */.Vl ? brief.slice(0, Constants/* CATEGORY_DESCRIPTION_WORD_LIMIT */.Vl).concat("...") : brief
                            })
                        })
                    ]
                })
            ]
        })
    }, categoryId);
};
/* harmony default export */ var Categories_CategoryCard = (CategoryCard);

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__("./node_modules/react-i18next/dist/es/useTranslation.js");
// EXTERNAL MODULE: ./src/data/AllCategoriesData.ts
var AllCategoriesData = __webpack_require__("./src/data/AllCategoriesData.ts");
;// CONCATENATED MODULE: ./src/pages/categories/index.tsx







const CATEGORY_HEADER = "Explore your endless curiosities in different categories on IQ.Wiki, Ranging from NFTs, to DeFi, Cryptocurrencies and more.";
const Categories = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Wiki Category",
                description: CATEGORY_HEADER,
                openGraph: {
                    title: "Wiki Category",
                    description: CATEGORY_HEADER
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                mt: "-12",
                pb: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        py: 10,
                        pt: 20,
                        width: "full",
                        objectFit: "cover",
                        bgColor: "careersBackground",
                        backgroundImage: "/images/backgrounds/homepage-bg-white.png",
                        _dark: {
                            backgroundImage: "/images/backgrounds/careers-background-dark.png"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                fontSize: {
                                    base: 25,
                                    lg: 36
                                },
                                maxW: "80%",
                                mx: "auto",
                                textAlign: "center",
                                p: 10,
                                as: "h1",
                                children: "".concat(t("wikiCategory"))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                textAlign: "center",
                                justifyContent: "center",
                                fontWeight: "400",
                                mx: "auto",
                                maxW: {
                                    base: "90%",
                                    md: "70%",
                                    lg: "60%"
                                },
                                px: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    mb: 7,
                                    mx: {
                                        base: "5",
                                        md: "8",
                                        lg: "14"
                                    },
                                    children: CATEGORY_HEADER
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        mt: 16,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                            columns: {
                                base: 1,
                                sm: 2,
                                lg: 3
                            },
                            width: "min(90%, 1200px)",
                            mx: "auto",
                            my: 12,
                            gap: 8,
                            children: AllCategoriesData/* AllCategoriesData */.V === null || AllCategoriesData/* AllCategoriesData */.V === void 0 ? void 0 : AllCategoriesData/* AllCategoriesData.map */.V.map((category)=>category.cardImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_CategoryCard, {
                                    imageCard: category.cardImage,
                                    title: category.title,
                                    brief: category.description,
                                    categoryId: category.id,
                                    coverIcon: category.icon
                                }, category.id))
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var categories = (Categories);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fcategories%2Findex.tsx&page=%2Fcategories!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);